export { CommentsController } from './controller/CommentsController';
export { InlineCommentPillController } from './controller/InlineCommentPillController';
export { useBlockThreadAnchors } from './hooks/useBlockThreadAnchors';
export type { ThreadMarkInput } from './utils/inject-thread-marks';
export { injectThreadMarks, parseThreadMarkIds, THREAD_MARK_SELECTOR } from './utils/inject-thread-marks';
export { getSegmentAnchorOffset, projectAnchorsOntoSegment } from './utils/segment-anchors';
